<template>

    <admin-layout>

        <app-content-pane class="ml-3">
            <template #title>
                <div class="px-4 pt-3">
                    <h1>Your Student Action Projects</h1>
                    <nav>
                        <ol class="breadcrumb">
<!--                            <li class="breadcrumb-item"><inertia-link :href="route('project.dashboard', {...global_url_params})">Change Projects</inertia-link></li>-->
                            <li class="breadcrumb-item active">Student Action Projects engage students to turn their awareness of social causes into action.</li>
                        </ol>
                    </nav>
                </div>
                <hr class="mb-0">
                <div class="actions px-4 pt-3">
                    <div class="form-group">
                        <input type="text"
                               v-model="filters.q"
                               class="form-control"
                               placeholder="Search Projects">
                    </div>
<!--                    <div class="form-group">-->
<!--                        <select class="form-control" v-model="filters.status">-->
<!--                            <option value="active">Active Projects</option>-->
<!--                            <option value="closed">Closed Projects</option>-->
<!--                        </select>-->
<!--                    </div>-->
<!--                    <div class="form-group">-->
<!--                        <select class="form-control" v-model="filters.team">-->
<!--                            <option value="">All Teams</option>-->
<!--                            <option :value="team" v-for="team in teams">{{ team.name }}</option>-->
<!--                        </select>-->
<!--                    </div>-->
                    <div class="form-group">
                        <select class="form-control" v-model="filters.theme">
                            <option value="">All Goals</option>
                            <option v-for="theme in themes" :key="theme.id" :value="theme">{{ theme.name }}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <select class="form-control" v-model="filters.path">
                            <option value="">All Learning Paths</option>
                            <option v-for="path in learning_paths" :key="path.id" :value="path">{{ path.name }}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <inertia-link v-if="current_user_is_paid"
                                      :href="route('project.create', {...global_url_params})"
                                      class="btn btn-primary d-flex align-items-center justify-content-center">
                            <img src="/images/icons/plus-circle-solid-light.svg" class="mr-2" alt="">
                            Create New Project
                        </inertia-link>
                    </div>
                </div>
            </template>

            <section>
                <div class="project-list px-4 py-3">
                    <div class="row align-items-stretch">
                        <transition-group name="fade">
                            <div v-for="project in filtered_projects" :key="project.id" class="col-lg-6 col-xl-4">
                                <project-card :project="project"
                                              :show-more-info="true"
                                              :show-delete="true"
                                              :manage-teams="false"
                                              :show-clone="true"
                                              @cloned="cloned($event)"
                                              class="mb-4"/>
                            </div>
                        </transition-group>
                    </div>
                </div>
            </section>

        </app-content-pane>

    </admin-layout>

</template>

<script>
import Welcome from '@/Jetstream/Welcome'
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import DashboardToolbox from "@/Components/Toolbox/DashboardToolbox";
import ProjectCard from "@/Components/Project/ProjectCard";
import Button from "@/Jetstream/Button";
import themes from "@/DATA/themes";
import ProjectSettingsModal from "@/Components/Project/ProjectSettingsModal";

export default {
    name: "Index",
    components: {ProjectSettingsModal, Welcome, AdminLayout, AppContentPane, DashboardToolbox, Button, ProjectCard},
    props: ['projects', 'learning_paths', 'teams', 'organizations'],

    data(){
        return {
            themes: themes,
            filters: {
                q: '',
                status: 'active',
                team: '',
                theme: '',
                path: '',
            },
            selected_project: null,
        }
    },


    computed: {
        filtered_projects(){
            const q = this.filters.q.toLowerCase();
            return this.projects.filter((project) => {

                if( q && project.name.toLowerCase().indexOf( q ) < 0 ){
                    return false;
                }

                if( this.filters.team && project.teams.filter( team => team.id === this.filters.team.id ).length === 0 ){
                    return false;
                }

                if( this.filters.theme && project.theme != this.filters.theme.id ){
                    return false;
                }

                if( this.filters.path && project.learning_path.id !== this.filters.path.id ){
                    return false;
                }

                return true;
            })
        },

    },


    methods: {
        randomProjectName(){
            const names = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras luctus dictum lorem ut pulvinar. Aenean neque neque, pharetra id nulla nec, euismod dignissim libero. Fusce tempor lobortis fringilla. Mauris sit amet urna non felis ornare tincidunt. Praesent tempus est nunc, nec faucibus justo fermentum in. Phasellus pharetra ut odio et placerat. Maecenas euismod semper quam ut hendrerit. Curabitur suscipit varius libero, eu aliquam ligula condimentum non. Fusce eu diam ac augue finibus aliquam. Vivamus pellentesque ornare justo, volutpat rhoncus ex tempor vitae. Sed scelerisque odio a ex ultricies, nec elementum ligula imperdiet. Morbi ut dolor faucibus, tristique mauris at, mollis ipsum. Donec non varius elit, sit amet dignissim mauris. Vivamus metus risus, tincidunt eget est sed, varius luctus erat. Maecenas rhoncus ac arcu ut elementum. Nam urna felis, congue a nisi sed, semper tincidunt tortor. Curabitur rhoncus quam at arcu rhoncus, aliquam commodo dui pellentesque. Pellentesque feugiat vulputate augue et cursus. Ut urna ex, sagittis vel viverra ac, ullamcorper quis mi. Vestibulum blandit ultrices diam in finibus.'
                .split('.');
            return names[ parseInt( Math.random() * names.length ) ];
        },

        randomProjectTheme(){
            const idx = parseInt( Math.random() * this.themes.length );
            return {
                id: (idx + 1),
                name: this.themes[ idx ].name,
            };
        },

        randomProjectLearningPath(){
            const idx = parseInt( Math.random() * this.learning_paths.length );
            return {
                id: (idx + 1),
                name: this.learning_paths[ idx ],
            };
        },

        selectProject(project){
            this.selected_project = project;
        },

        deselectProject(){
            this.selected_project = null;
        },

        cloned(project){
            // this.$inertia.reload({only: ['projects']});
            this.$inertia.visit( this.route('project.details', {project: project.id, ...this.global_url_params}) );
        }

    },


    mounted() {

        this.setTitle('Projects');

    }

}
</script>

<style lang="scss" scoped>
.actions{
    display: flex;

    .form-group{
        flex-grow: 1;
        padding: 0 0.6rem;

        &:first-child, &:last-child{
            padding: 0;
        }
    }
}

@media (min-width: 650px) and (max-width: 900px){
    .actions{
        display: flex;
        flex-direction: column;

        .form-group{
            flex-grow: 1;
            padding: 0 0.6rem;

            &:first-child, &:last-child{
                padding: 0rem 0.6rem 0rem 0.6rem;
            }
        }
    }
}

.fade-enter-active {
    transition: all 0.3s ease-out;
}

.fade-leave-active {
    transition: all 0.3s ease-in;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
}

</style>
